import { gql } from "@apollo/client";

export const DELETE_QUEUE_RECORD_MUTATION = gql`
  mutation DeleteQueueRecord($id: ID!) {
    deleteQueueRecord(id: $id) {
      success
      error
    }
  }
`;
